// extracted by mini-css-extract-plugin
export default {"cls1":"Timer-cls1_YZS","cls2":"Timer-cls2_wOe Timer-cls1_YZS","mini":"Timer-mini__Vp","dark":"Timer-dark_M0Q"};